<template>
  <b-modal
    ref="bModal"
    hide-backdrop
    hide-footer
    title="Finalizar corte"
    centered
    modal-class="modalCut"
    style="z-index:10000"
    @hide="onHide"
    @show="onShow"
  >
    <!--Header Section-->
    <b-row class="header pl-3 justify-content-center">
      <b-col
        cols="auto"
        class="main-info d-flex pl-2"
      >
        <div
          style="width: 40px"
          class="d-flex align-items-center justify-content-center portionIcon"
        >
          <i
            v-if="isDepleted"
            class="icon-block-slash main mr-1"
            aria-hidden="true"
          />
          <i
            v-else
            class="main mr-1"
            :class="PORTION_TYPES[portion.portionType.portionTypeEnum].icon"
            aria-hidden="true"
          />
        </div>
        <div class="text-section d-flex flex-column justify-content-center ml-2">
          <span
            class="primary-dark-color font-weight--medium"
            qa="modal-cut-portion-label"
          >{{ externalId }}</span>
          <small qa="modal-cut-portion-location">{{ location }}</small>
        </div>
      </b-col>
      <b-col
        cols="2"
        class="main-info d-flex pl-2"
      >
        <div class="text-section d-flex flex-column justify-content-center ml-3 mt-1">
          <small>{{ $t('grid.detail.patName') }}</small>
          <h4
            class="collapsable-card-title inside mb-0"
            qa="modal-cut-portion-pathologist"
          >
            {{ pathologist }}
          </h4>
        </div>
      </b-col>
      <b-col
        cols="2"
        class="orientation main-info d-flex pl-2"
      >
        <div class="text-section d-flex flex-column justify-content-center ml-3 mt-1">
          <small>{{ $t('laboratory.tracking.orientation') }}</small>
          <h4
            v-if="portion && portion.fragmentOrientation"
            class="collapsable-card-title inside mb-0"
            qa="modal-cut-portion-orientation"
          >
            <i
              :class="portion.fragmentOrientation.forIconName"
              class="main mr-1"
              aria-hidden="true"
            />
            {{ portion.fragmentOrientation.forDescription }}
          </h4>
          <h4
            v-else
            class="collapsable-card-title inside mb-0"
          >
            -
          </h4>
        </div>
      </b-col>
      <b-col
        cols="2"
        class="main-info d-flex pl-2"
      >
        <div class="text-section d-flex flex-column justify-content-center ml-3 mt-1">
          <small>{{ $t('laboratory.tracking.processor') }}</small>
          <h4
            class="collapsable-card-title inside mb-0"
            qa="modal-cut-portion-processor"
          >
            {{ portion.porTissueProcessor ? portion.porTissueProcessor : '-' }}
          </h4>
        </div>
      </b-col>
      <b-col
        cols="auto"
        class="main-info d-flex pl-2"
      >
        <div class="text-section d-flex flex-column justify-content-center ml-3 mt-1">
          <small>{{ $t('laboratory.tracking.fragmentsNumber') }}</small>
          <h4
            class="collapsable-card-title inside mb-0"
            qa="modal-cut-portion-fragments"
          >
            {{ portion.porFragments }}
          </h4>
        </div>
      </b-col>
      <!-- TODO: Front development required -->
      <b-col
        v-if="false"
        cols="2"
        class="main-info d-flex pl-2"
      >
        <div class="text-section d-flex flex-column justify-content-center ml-3 mt-1">
          <small>{{ $t('laboratory.grid.lastSubportionCutDate') }}</small>
          <h4 class="collapsable-card-title inside mb-0">
            00/00/0000 00:00
          </h4>
        </div>
      </b-col>
      <b-col class="d-flex justify-content-end align-items-center">
        <!-- TODO: Cancellation front development required -->
        <b-button
          v-if="false"
          class="tr-btn main ml-3 mr-1 d-flex align-items-center justify-content-center"
          qa="modal-cut-portion-cancellation-button"
        >
          <i
            class="far fa-times"
            aria-hidden="true"
          />
        </b-button>
        <b-button
          class="tr-btn main ml-2 d-flex align-items-center justify-content-center"
          qa="modal-cut-portion-manual-shipment-button"
          @click="showManualShipmentModal"
        >
          <i
            class="far fa-box"
            aria-hidden="true"
          />
        </b-button>
      </b-col>
    </b-row>

    <!--Subheader Section-->
    <b-row class="subheader py-2">
      <b-col class="d-flex align-items-center">
        <span>{{ totalSelection }} {{ $t('laboratory.tracking.contentSelected') }}</span>
      </b-col>
      <b-col class="d-flex justify-content-end align-items-center">
        <div class="d-flex">
          <div class="p-0 d-flex align-items-center mr-2">
            <input
              id="toggle-cut-modal"
              v-model="isDepleted"
              v-testing="'depleted-switch'"
              type="checkbox"
              class="offscreen"
              aria-hidden="true"
              @change="onDepletedSwitchChange"
            >
            <label
              for="toggle-cut-modal"
              class="switch mb-0"
            />
          </div>
          <span class="mr-4">{{ $t('laboratory.tracking.depletedBlock') }}</span>
        </div>
        <b-button
          id="pop-label"
          class="tr-btn main"
          qa="modal-cut-list-button"
        >
          <i
            class="fal fa-list-ul"
            aria-hidden="true"
          />
        </b-button>
        <!--Pop Over-->
        <b-popover
          target="pop-label"
          title="Popover"
          placement="bottom"
          triggers="click blur"
        >
          <div class="pop-labels p-2">
            <div
              v-for="assayState in ASSAY_STATES"
              :key="assayState.code"
              class="pop-labels-container"
            >
              <div class="pop-labels-row d-flex py-2 px-1 align-items-center">
                <div
                  class="state-circle mr-2"
                  :class="assayState.class"
                /><span>{{ assayState.name }}</span>
              </div>
            </div>
          </div>
        </b-popover>
        <b-button
          v-if="$_canPrintSubportion()"
          v-testing="'print-subportion-labels'"
          :disabled="!totalSelection"
          class="tr-btn main ml-3"
          @click="printSubportionsLabels"
        >
          <i
            class="fal fa-ticket-alt"
            aria-hidden="true"
          />
        </b-button>
        <b-button
          v-testing="'instrument'"
          :disabled="!canAddDevice"
          class="tr-btn main ml-3 d-flex align-items-center justify-content-center"
          @click="openDevicesModalForm()"
        >
          <i
            class="icon-instrument"
            aria-hidden="true"
          />
        </b-button>
        <b-button
          v-if="$_canCreateIncident()"
          v-testing="'incidents'"
          :disabled="totalSelection !== 1"
          class="tr-btn error ml-3"
          @click="showIncidentFormModal"
        >
          <i
            class="fal fa-exclamation-triangle"
            aria-hidden="true"
          />
        </b-button>
        <b-button
          v-if="$_canPrintSubportion() && hasOperationInCurrentLaboratoryGlobalMixin(selectedOption.id)"
          v-testing="'apply-action'"
          :disabled="!selectedElements.length || selectedElementsNotPending.length > 0"
          class="tr-btn go ml-3"
          @click="applyAction"
        >
          <i
            class="fal fa-arrow-right"
            aria-hidden="true"
          />
        </b-button>
      </b-col>
    </b-row>

    <!--Content Section-->
    <b-row class="content px-3 mt-2">
      <b-col>
        <div
          v-if="cardsPending.length"
          qa="modal-cut-pending-content"
        >
          <span class="state-header">{{ cardsPending[0].assayStatus.name }}</span>
          <b-row
            v-for="(card) in cardsPending"
            :key="card.cardId"
          >
            <b-col @click="selectElement(card)">
              <cut-card-tracking :information="card" />
            </b-col>
          </b-row>
        </div>
        <div
          v-if="cardsProcess.length"
          qa="modal-cut-process-content"
        >
          <span class="state-header">{{ cardsProcess[0].assayStatus.name }}</span>
          <b-row
            v-for="(card) in cardsProcess"
            :key="card.cardId"
          >
            <b-col @click="selectElementNotPending(card)">
              <cut-card-tracking :information="card" />
            </b-col>
          </b-row>
        </div>
        <div
          v-if="cardsCompleted.length"
          qa="modal-cut-completed-content"
        >
          <span class="state-header">{{ cardsCompleted[0].assayStatus.name }}</span>
          <b-row
            v-for="(card) in cardsCompleted"
            :key="card.cardId"
          >
            <b-col @click="selectElementNotPending(card)">
              <cut-card-tracking :information="card" />
            </b-col>
          </b-row>
        </div>
        <div
          v-if="cardsCancel.length"
          qa="modal-cut-cancel-content"
        >
          <span class="state-header">{{ cardsCancel[0].assayStatus.name }}</span>
          <b-row
            v-for="(card) in cardsCancel"
            :key="card.cardId"
          >
            <b-col @click="selectElementNotPending(card)">
              <cut-card-tracking :information="card" />
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <print-component ref="printComponent" />
    <modal-incident-form
      v-if="selectedElements.length === 1"
      ref="incidentFormModal"
      :id-value="selectedElements[0].supLabel"
      @incidentAdded="onIncidentAdded"
    />
    <laboratory-tracking-instrument-modal-form
      ref="laboratoryTrackingInstrumentModalForm"
      :title="$tc('global.cuttingDevice')"
      :options="selectedElements"
      :devices="instrumentOptions"
      :fixed-device="instrumentSelected"
      @device-applied="onDeviceApplied"
    />
    <manual-shipment
      ref="manualShipmentContentTracking"
      :portions="selectedPortionsForManualShipment"
      @manualShipmentApplied="onManualShipmentApplied"
    />
  </b-modal>
</template>

<script>
import CutCardTracking from '@/modules/laboratoryModule/laboratoryTracking/CutCardTracking'
import laboratoryDynamicServices from '../../services/laboratoryDynamicServices'
import ModalIncidentForm from '@/modules/laboratoryModule/laboratoryTracking/modals/ModalIncidentForm'
import { PORTION_TYPES } from '@/api/resources/portionTypeService'
import { ASSAY_STATES, assayState } from '@/api/resources/entityState/assay-state'
import laboratorySidebarStore from '@/modules/laboratoryModule/sideBar/laboratorySideBarStore'
import { SubportionOperationGuardMixin } from '@/api/operations/mixins/guards/subportion-operation-guard.mixin'
import { IncidentOperationGuardMixin } from '@/api/operations/mixins/guards/incident-operation-guard.mixin'
import instrumentsMixin from '@/modules/laboratoryModule/mixins/instrumentsMixin'
import LaboratoryTrackingInstrumentModalForm
    from '@/modules/laboratoryModule/laboratoryTracking/modals/LaboratoryTrackingInstrumentModalForm'
import ManualShipment from '@/components/manual-shipment/manual-shipment.vue'
import { commonPortionService } from '@/api/services/common/portion/common-portion.service'
import apiExceptionType from '@/utils/apiExceptionType'

export default {
    name: 'ModalCut',
    components: {
        CutCardTracking,
        ModalIncidentForm,
        LaboratoryTrackingInstrumentModalForm,
        ManualShipment
    },
    mixins: [
        SubportionOperationGuardMixin,
        IncidentOperationGuardMixin,
        instrumentsMixin
    ],
    props: {
        blockId: { type: Number },
        portion: { type: Object },
        externalId: { type: String },
        location: { type: String }
    },
    data() {
        return {
            selectedNumber: 0,
            selectedElements: [],
            selectedElementsNotPending: [],
            cardsCompleted: [],
            cardsPending: [],
            cardsProcess: [],
            cardsCancel: [],
            isDepleted: false,
            showProcessButton: false
        }
    },
    computed: {
        selectedPortionsForManualShipment() {
            return [{
                caseId: this.portion.sample.caseStudy.casId,
                sampleId: this.portion.sample.samId,
                portionId: this.portion.porId,
                label: this.portion.porLabel
            }]
        },
        PORTION_TYPES() {
            return PORTION_TYPES
        },
        pathologist() {
            return this.portion && this.portion.sample.caseStudy.pathologist.fullName
        },
        totalSelection() {
            return this.selectedElements.length + this.selectedElementsNotPending.length
        },
        ASSAY_STATES() {
            return assayState.states
        },
        sectionIds() {
            return laboratorySidebarStore.state.sectionIds
        },
        canAddDevice() {
            return !this.selectedOption?.elementWithoutOperation && !!this.totalSelection && !!this.instrumentOptions.length
        }
    },
    watch: {
        async selectedOption() {
            if (this.selectedOption) {
                await this.getData()
                this.selectAllPendingElements()
            }

            this.resetInstrumentsData()
        }
    },
    methods: {
        onIncidentAdded() {
            this.$emit('incidentAdded')
        },
        async onDepletedSwitchChange() {
            if (this.isDepleted) {
                const [error] = await this.markPortionAsDepleted()
                if (error) {
                    if (error.response?.data?.code === apiExceptionType.MARK_AS_DEPLETED_PORTION_HAS_SUBPORTIONS_PENDING_CUT) {
                        const shouldCancelSubportionsPendingCut = await this.$_showConfirmationModal(error.response.data.message)
                        if (shouldCancelSubportionsPendingCut) {
                            const [error2] = await this.markPortionAsDepleted(true)
                            if (error2) {
                                this.$_showErrorModal()
                                this.isDepleted = false
                            } else {
                                this.$_showToastSuccess(this.$tc('laboratory.content.blockMarkAsDepletedSuccessfully'))
                                this.$emit('allPendingCutSubportionsCancelled')
                            }
                        } else {
                            this.isDepleted = false
                        }
                    } else {
                        this.$_showErrorModal()
                        this.isDepleted = false
                    }
                } else {
                    this.$_showToastSuccess(this.$tc('laboratory.content.blockMarkAsDepletedSuccessfully'))
                    this.isDepleted = true
                }
            } else {
                if (await this.markPortionAsNonDepleted()) {
                    this.isDepleted = false
                } else {
                    this.isDepleted = !this.isDepleted
                }
            }
        },
        async markPortionAsNonDepleted() {
            const element = {
                caseId: this.portion.sample.caseStudy.casId,
                portionId: this.portion.porId,
                sampleId: this.portion.sample.samId
            }
            return this.$_toCallUnique(commonPortionService.markPortionsAsNonDepleted(this.$store.getters.labId, [element]))
        },
        async markPortionAsDepleted(cancelSubportionsPendingCut = false) {
            const entityIds = [{
                caseId: this.portion.sample.caseStudy.casId,
                portionId: this.portion.porId,
                sampleId: this.portion.sample.samId
            }]
            const laboratoryId = this.$store.getters.labId
            return this.toCall(commonPortionService.markPortionsAsDepleted(laboratoryId, entityIds, cancelSubportionsPendingCut))
        },
        onHide() {
            this.$emit('onHide')
        },
        showManualShipmentModal() {
            this.$refs.manualShipmentContentTracking.show()
        },
        onManualShipmentApplied() {
            this.hide()
        },
        openDevicesModalForm() {
            this.$refs.laboratoryTrackingInstrumentModalForm.show()
        },
        showIncidentFormModal() {
            const selectedElement = this.selectedElements[0]
            const entityIds = [
                selectedElement.portion.sample.caseStudy.casId,
                selectedElement.portion.sample.samId,
                selectedElement.portion.porId,
                selectedElement.supId
            ]
            this.$refs['incidentFormModal'].show(this.selectedOption.type.toUpperCase(), entityIds, null, selectedElement)
        },
        async printSubportionsLabels() {
            if (this.selectedElements.length) {
                const printSubportionsLabelsCall = await this.$refs.printComponent.printSubportionsLabels(
                    this.$store.getters.labId,
                    this.portion.sample.caseStudy.casId,
                    this.portion.sample.samId,
                    this.portion.porId,
                    this.selectedElements)
                if (printSubportionsLabelsCall) {
                    await this.getData()
                    this.updateSelectedElements()
                }
            }
        },
        async applyAction() {
            if (this.selectedElements.length) {
                this.updateLoading(true)
                await this.printSubportionsLabels()
                const params = this.selectedElements.map((elem) => {
                    return {
                        caseId: elem.portion.sample.caseStudy.casId,
                        portionId: elem.portion.porId,
                        sampleId: elem.portion.sample.samId,
                        subportionId: elem.supId
                    }
                })
                let [err] = await this.toCall(laboratoryDynamicServices.applyAction(
                    this.$store.getters.labId,
                    this.selectedOption.sectionId,
                    this.selectedOption.actionUrl,
                    params
                ))
                this.updateLoading(false)
                if (err) {
                    this.showErrorModalGlobal(this.$t('laboratory.content.errorAction'))
                    return
                }
                this.showSuccessModalGlobal(this.$t('laboratory.content.actionOk'))
                this.$eventHub.$emit('updateTaskCount')
                this.$emit('actionApplied')
                this.hide()
                this.updateLoading(false)
            }
        },
        selectAllPendingElements() {
            this.cardsPending.forEach((item) => this._selectElement(this.selectedElements, item))
        },
        async getSubportions() {
            return this.$_toCallUnique(laboratoryDynamicServices.getSubportions(this.$store.getters.labId, this.portion.sample.caseStudy.casId,
                this.portion.sample.samId, this.portion.porId))
        },
        async getSubportionsPendingSlide() {
            return this.$_toCallUnique(
                laboratoryDynamicServices.getSubportionsPendingSlide(
                    this.$store.getters.labId,
                    this.portion.sample.caseStudy.casId,
                    this.portion.sample.samId,
                    this.portion.porId,
                    this.sectionIds
                ))
        },
        updateSelectedElements() {
            const allCards = [...this.cardsProcess, ...this.cardsCancel, ...this.cardsCompleted, ...this.cardsPending]
            this.selectedElements.forEach((element, index) => {
                const foundElement = allCards.find(card => card.supId === element.supId)
                if (foundElement) {
                    this.selectedElements[index] = foundElement
                }
            })
        },
        async getData() {
            this.isDepleted = this.portion.depleted
            const subportions = await this.getSubportions()
            if (subportions) {
                this.cardsProcess = subportions.content.filter((elem) => elem.assayStatus.code === ASSAY_STATES.IN_PROCESS.code)
                this.cardsCancel = subportions.content.filter((elem) => elem.assayStatus.code === ASSAY_STATES.CANCELED.code)
                this.cardsCompleted = subportions.content.filter((elem) => elem.assayStatus.code === ASSAY_STATES.FINISHED.code)
            }
            const subportionsPendingSlide = await this.getSubportionsPendingSlide()
            if (subportionsPendingSlide) {
                this.cardsPending = subportionsPendingSlide.content
            }
        },
        async onShow() {
            await this.getData()
            this.selectAllPendingElements()
        },
        show() {
            this.$refs.bModal.show()
        },
        hide() {
            this.$refs.bModal.hide()
        },
        async _selectElement(selectedElements, element) {
            const selectedIndex = selectedElements.findIndex((item) => item.supId === element.supId)
            if (selectedIndex !== -1) {
                this.selectedElements.splice(selectedIndex, 1)
            } else {
                this.selectedElements.push(element)
            }

            await this.loadInstrumentOptions(this.selectedElements)

            this.$forceUpdate()
        },
        async selectElement(element) {
            await this._selectElement(this.selectedElements, element)
        },
        async selectElementNotPending(element) {
            await this._selectElement(this.selectedElementsNotPending, element)
        },
        async onDeviceApplied(deviceFixed) {
            this.instrumentSelected = deviceFixed

            await this.getData()
            this.selectAllPendingElements()
        }
    }
}
</script>

<style>

.modalCut .modal-dialog{
    max-width: 90% !important;
}

.modalCut .modal-body{
    padding: 0 1.1rem 0 1.1rem !important;
}

.modalCut .modalPrintConfiguration .modal-dialog{
    max-width: 35% !important;
}

.modalCut .confModalTracking .modal-dialog{
  max-width: 80% !important;
}

.modalCut .printModal .modal-dialog{
    max-width: 40% !important;
}

.modalCut .printModal .modal-body{
    padding: 20px 0 !important;
}

.modalCut .modalPrintConfiguration .text-center {
  margin: 15px 0;
}

</style>

<style lang="scss" scoped>

.main-info h4{
  font-size: font-size(small);
  margin-top: 3px;
}

.orientation i::before {
  margin-left: 0;
}

.switch {
  position: relative;
  display: inline-block;
  width: 45px;
  height: 25px;
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  transition: all 0.3s;
  font-family: "fontello", sans-serif;
}

.switch::after {
  content: "\e813";
  position: absolute;
  width: 23px;
  height: 23px;
  padding: 2px 5px;
  border-radius: 18px;
  background-color: white;
  top: 1px;
  left: 1px;
  transition: all 0.3s;
}

input[type="checkbox"]:checked + .switch::after {
  transform: translateX(20px);
}

input[type="checkbox"]:checked + .switch {
  background-color: vt-color(primary);
}

input[type="checkbox"]:checked + .switch::after {
  color:vt-color(primary);
}

.offscreen {
  position: absolute;
  left: -9999px;
}

.modalCut .main-info {
  cursor: pointer;
}

.modalCut .main-info img {
  width: 35px;
}

.modalCut .main-info span {
  font-size: font-size(normal);
}

.modalCut .main-info small {
  font-size: 11px;
}

.modalCut .main-info .flex-column {
  line-height: 12px;
}

.modalCut .main-info .text-section {
  margin-top: 5px;
}

.modalCut {
    color: #303133;
}

.modalCut .state-header{
  margin-left: -12px;
}

.modalCut h4{
  font-weight: normal;
}

.modalCut .info-icon{
  font-size: 20px;
}

.modalCut .header{
  border-bottom: 1px solid #d8d8d8;
  padding: 5px 0;
}

.modalCut .subheader{
  border-bottom: 1px solid #d8d8d8;
  padding: 5px 0;
}

.modalCut .content{
  height: calc(100vh - 260px);
  overflow: hidden;
  overflow-y: auto;
}

.modalCut .vertical-line{
  height: 100%;
}

.tr-btn{
  border-radius: 50%;
  width: 40px;
  height: 40px;
  background: #FFF;
  border-color: #d8d8d8;
}

.tr-btn.main:hover{
  color: vt-color(primary);
}

.tr-btn.error:hover{
  color: #fc6274;
}

.tr-btn.go {
    background: #2ecc71;
}

.portionIcon i {
 font-size: 30px;
}

</style>
